// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__pxALl","next":"styles_next__lDDZT","editorGrid":"styles_editorGrid__UV3TZ"};